import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CrudService } from "./crud.service";
import { environment } from "../../environments/environment";
import { TicketMessage } from "../models/ticket-message";

@Injectable({
  providedIn: "root",
})
export class TicketMessagesService extends CrudService<TicketMessage, number> {
  constructor(protected override _http: HttpClient) {
    super(_http, `${environment.baseUrl}/ticket_messages`);
  }
}
